import { MatchKey_Read } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class MatchKey {
  constructor(
    private _id: string,
    private _key: string,
    private _matchable_type: MatchKey_Read['matchable_type'],
    private _matchable_id: string,
    private _company_id: string,
    private _created_at: Dayjs,
  ) {}

  public get id() {
    return this._id;
  }
  public get key() {
    return this._key;
  }
  public get matchableType() {
    return this._matchable_type;
  }
  public get matchableId() {
    return this._matchable_id;
  }
  public get companyId() {
    return this._company_id;
  }
  public get createdAt() {
    return this._created_at;
  }

  public static parse(proto: MatchKey_Read) {
    return new MatchKey(
      proto.id,
      proto.key,
      proto.matchable_type,
      proto.matchable_id,
      proto.company_id,
      dayjs(proto.created_at),
    );
  }
}
